import { API_BASE_URL } from "../urls.api";

export const BOOKINGS_URL = `${API_BASE_URL}/bookings`;
export const BOOKINGS_IMPORT_URL = `${BOOKINGS_URL}/import`;
